<div class="fw-bold">
    <ng-container>{{ label }}</ng-container>
</div>
<div class="text-end" style="display: grid; grid-template-columns: auto 4rem">
    <div>
        @for (value of values; track value) {
            @if (value.length > 0) {
                {{ value }}<br />
            }
        }
    </div>
    <div style="white-space: nowrap; padding-right: 0.1rem">
        @if (allowEdit) {
            <button type="button" class="btn btn-text-primary p-0" (click)="updateValue()">
                <i class="bi bi-pencil pe-2"></i>
            </button>
        }
        @if (toolTip != null) {
            <button type="button" class="btn btn-text-primary p-0">
                <i
                    class="bi bi-info-circle"
                    popoverClass="custom-popover"
                    ngbPopover="{{ toolTip }}"
                    container="body"></i>
            </button>
        }
    </div>
</div>
